/* eslint-disable react/prop-types */
import { withStyles } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import { ExpansionPanel } from '../../../../../../forms/form-components/expansion-panel/expansion-panel';
import styles, { StyledComponent } from '../../../../../../styles/styles';
import { PersonalDetailsView } from '../../details/personal-detail';
import { AddressDetailsView } from '../../details/address-details';
import { ContactDetailsView } from '../../details/contact-details';
import { EmploymentDetailsView } from '../../details/employment-details';
import { FormDetails } from '../../form-details-reducer';
import { Nullable } from '../../../../../../shared-types';
import { ClaimType } from '../../../../../../claim/claim-types';

interface BaseProps {
    formDetails?: FormDetails;
    disableEditButton?: boolean;
    claimType?: Nullable<ClaimType>;
}

interface Props extends StyledComponent, BaseProps {}

const policyHolderDetailsView: React.FunctionComponent<Props> = ({
    formDetails,
    disableEditButton,
    claimType,
}) => {
    return (
        <ExpansionPanel name="Policyholder details" style={{ marginLeft: -24, marginRight: -24 }}>
            <React.Fragment>
                <PersonalDetailsView
                    type="PolicyHolder"
                    formDetails={formDetails}
                    disableEditButton={disableEditButton}
                />
                <AddressDetailsView
                    type="PolicyHolder"
                    formDetails={formDetails}
                    disableEditButton={disableEditButton}
                />
                {claimType !== ClaimType.Disability && (
                    <ContactDetailsView
                        type="PolicyHolder"
                        formDetails={formDetails}
                        disableEditButton={disableEditButton}
                    />
                )}
                {claimType !== ClaimType.Disability && (
                    <EmploymentDetailsView
                        formDetails={formDetails}
                        disableEditButton={disableEditButton}
                    />
                )}
            </React.Fragment>
        </ExpansionPanel>
    );
};

export const PolicyHolderDetailsView = withStyles(styles)(policyHolderDetailsView);
